<template>
  <td
    class="expandable-cell"
    :style="{maxWidth: `${maxWidth}px`}"
    @mouseenter="isVisible = true"
    @mouseleave="isVisible = false">
    <div class="expandable-cell__short">
      {{content}}
    </div>
    <div
      class="expandable-cell__full"
      v-if="isVisible">
      {{content}}
    </div>
  </td>

</template>

<script>
export default {
  name: 'ExpandableCell',
  props: {
    content: String,
    maxWidth: {
      type: String,
      default: () => '50',
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
};
</script>

<style lang="scss">
.expandable-cell{
  position: relative;
  &__short{
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__full{
    position: absolute;
    top: 0;
    left: -3px;
    padding: 7px 4px 4px 4px;
    white-space: pre-wrap;
    background: #eee;
    z-index: 50;
    max-width: 100%;
    min-height: 36px;
  }
}
</style>
